module.exports = __webpack_public_path__ + "media/images/emblems/Diessbach_bei_Bueren-coat_of_arms-9103d658c15c840d434e8ca58ada6aac.svg";